import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import Link from '../base/Link';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth, { hasPermission } from "../auth/Auth";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from '../base/Translation';

export default class ErrorDBView extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_error_db: "/error_db/save/:error_db",
			get_error_db: "/error_db/fetch/:error_db",
			clone_error_db: "/error_db/clone/:error_db",
			delete_error: "/error/delete/:error"
		});

		this.state = {
			error_db: null,
			tableData: [],
			tableColumns: [
				{ name: "code", display: translate("Kód chyby"), sort: true, width: 11 },
				{ name: "component", display: translate("Proces / komponent / parameter"), sort: true, width: 25 },
				{ name: "group", display: translate("Skupina"), sort: true, width: 20 },
				{ name: "state_before", display: translate("Stav pred testom"), sort: true, width: 25 },
				{ name: "points", display: translate("Body vyhovel / nevyhovel"), sort: true, width: 15 },
				{ name: "options", display: " ", width: 4 }
			]
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	convertDataForTable(data) {
		return data.map(function (error) {
			let data = {};
			data.code = error.code;
			data.points = error.points + " / " + error.negative_points;
			data.component = <Link permission="ErrorEdit" to={"/error_dbs/" + this.props.params.error_db_ID + "/error/edit/" + error.id}>{error.component}</Link>
			data.group = error.group;
			data.state_before = error.state_before;
			data.options = (
				<div style={{textAlign: "right"}}>
					<DeleteButton onClick={this.onDelete.bind({
						error: error.id,
						currentComponent: this
					})} permission="ErrorNew" />
				</div>
			);
			return data;
		}.bind(this));
	}

	fetchData() {
		this.api.request({
			route: "get_error_db",
			params: { error_db: this.props.params.error_db_ID },
			success: (response) => {
				let tableData = this.convertDataForTable(response.errors);
				this.setState({ error_db: response, tableData });
			}
		});
	}

	onSave(evt) {
		this.api.request({
			route: "save_error_db",
			params: { error_db: this.props.params.error_db_ID },
			data: this.state.error_db,
			created: (response) => {
				browserHistory.push("/error_dbs");
			}
		});
	}

	onDuplicate(evt) {
		this.api.request({
			route: "clone_error_db",
			params: { error_db: this.props.params.error_db_ID },
			success: (response) => {
				this.fetchData();
			}
		});
	}

	onChange(evt) {
		// Get protocol from state
		let newErrorDB = this.state.error_db;

		// Update it's value
		newErrorDB[evt.target.name] = evt.target.value;

		// Update vehicle in state
		this.setState({ error_db: newErrorDB });
	}

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	onDelete(evt) {
		this.currentComponent.api.request({
			route: "delete_error",
			params: { "error": this.error },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {

		if (this.state.error_db === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<SorTable
				columns={this.state.tableColumns}
				data={this.state.tableData}
				headers={true}
				searchBy="component"
				title={this.state.error_db.name}
				right={() => {
					return (
						<span>
							<Link permission="ErrorNew" className="btn btn-success btn-sm pull-right" to={"/error_dbs/" + this.props.params.error_db_ID + "/error/add/new"}>
								<i className="glyphicon glyphicon-plus" /> {translate("Pridať chybu")}
							</Link>
							{hasPermission("ErrorNew") ? <button className="btn btn-primary btn-sm pull-right" onClick={this.onDuplicate.bind(this)} >
								<i className="glyphicon glyphicon-copy" /> {translate("Duplikovať")}
							</button> : ""}
						</span>
					)
				}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/error_db/ErrorDBView.js